import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/http.ts";
import type { ListSlashCommandsResp } from "../types/slashCommands.ts";

const slashCommandQueries = {
  all: () => ["slash-commands"] as const,
  list: () =>
    queryOptions({
      queryKey: [...slashCommandQueries.all(), "list"] as const,
      queryFn: async ({ signal }) => {
        const response = await api.get<ListSlashCommandsResp>("/api/a/slash-commands", { signal });
        return response.data;
      },
    }),
};

export const useSlashCommands = () => {
  const { data, isLoading, error } = useQuery(slashCommandQueries.list());
  return { commands: data ?? [], isLoading, error };
};
